import { Body1, Switch, Text, makeStyles, tokens } from '@fluentui/react-components';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
    onMuteMicWhileSpeakingChanged,
    readMuteMicWhileSpeaking,
    writeMuteMicWhileSpeaking,
} from '../../libs/voice/voicePreferences';

const useClasses = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalM,
    },
    hint: {
        color: tokens.colorNeutralForeground3,
    },
});

/** Voice conversation settings: whether the microphone is off while the assistant speaks, for loudspeakers. */
export const VoiceSettingsSection: React.FC = () => {
    const classes = useClasses();
    const { t } = useTranslation();
    const [muteMicWhileSpeaking, setMuteMicWhileSpeaking] = useState(readMuteMicWhileSpeaking);
    // Settings open in another tab or window may change it, as the voice button follows too.
    useEffect(() => onMuteMicWhileSpeakingChanged(setMuteMicWhileSpeaking), []);

    return (
        <div className={classes.root}>
            <Text weight="semibold">{t('settings.voice.sectionTitle')}</Text>
            <Switch
                checked={muteMicWhileSpeaking}
                onChange={(_, data) => {
                    writeMuteMicWhileSpeaking(data.checked);
                    setMuteMicWhileSpeaking(data.checked);
                }}
                label={t('settings.voice.muteMicWhileSpeaking')}
                data-testid="voiceMuteMicWhileSpeakingSwitch"
            />
            <Body1 className={classes.hint}>{t('settings.voice.muteMicWhileSpeakingHint')}</Body1>
        </div>
    );
};
